module.exports = __webpack_public_path__ + "img/Layer 15.244d76ef.svg";